import { render, staticRenderFns } from "./ClientSettingEdit.vue?vue&type=template&id=61e3af2a&scoped=true"
import script from "./ClientSettingEdit.vue?vue&type=script&lang=js"
export * from "./ClientSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingEdit.vue?vue&type=style&index=0&id=61e3af2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3af2a",
  null
  
)

export default component.exports